export default __webpack_public_path__ + "static/realWorldImg3-fd7c5e7cde25bd003175b0315b0ded7d.png";